/**
 * filter hidden button from extended menu based on the device type
 * @param {Array} buttonList - list of extended buttons
 * @param {string} deviceType - type of device Phone|Tablet|Standard
 * @return {Array} return an Array of button in extended Button List that is visible to user
 */
export function filterHiddenExtendedButton(buttonList, deviceType) {
    return buttonList.filter(({ hiddenDeviceTypes }) =>
        (!hiddenDeviceTypes || hiddenDeviceTypes.indexOf(deviceType) === -1));
}
